export default "__VITE_ASSET__BCVu6Ilu__"